import React from "react";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

// import "./styles/PointsWithHeading.module.scss";

const HeadingWithPoints = ({ doc }) => {
  const {
    heading,
    internal_link_id,
    description,
    bg_color,
    text_alignment = "left",
  } = doc?.primary || {};

  const sectionStyle = { backgroundColor: bg_color };

  return (
    <div
      className="pt-md-5 pt-xl-5 pt-4 px-md-5 px-2xl-5 px-0 points-with-heading-section prismic-slice"
      style={sectionStyle}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width pwh-container">
        <div className={`text-md-${text_alignment} mb-5 mb-2xl-5 pwh-section-holder`}>
          <div className="sns-h3 text-theme-primary pwh-key-title same-size-title">
            {textResolver(heading)}
          </div>
          <div className="mt-2 mt-2xl-2 sns-h5 pwh-description-row">
            {textResolver(description)}
          </div>
        </div>
        <div className="pt-4 pt-2xl-4 d-flex flex-wrap justify-content-between position-relative pwh-blocks-container">
          {doc?.items?.map(({ text }, index) => (
            <div
              className="p-3 p-sm-4 p-md-3 p-lg-5 p-2xl-5 mx-md-3 mx-2xl-3 mt-4 mt-2xl-4 mb-5 mb-2xl-5 pt-md-4 pt-2xl-4 d-flex align-items-center position-relative bg-white pwh-key-content-block"
              key={index}
            >
              <div className="position-absolute d-flex align-items-center justify-content-center key-content-index text-white font-weight-bold">
                <span className="key-content-index-num">{index + 1}</span>
              </div>
              <div className="w-100 pt-5 pt-md-4 pt-2xl-4 text-center key-content-text">
                {textResolver(text)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default HeadingWithPoints;
